<script lang="ts">
  // The reusable GX rank chip: a school-coloured pip + tier label + (optional) rating.
  // Used in the world HUD, menu, leaderboard, player dialog, and duel end screen.
  import type { RankBrief, RankInfo, RankSchool } from "@ygoevo/world-protocol";

  let {
    rank,
    size = "md",
    showRating = true,
  }: { rank: RankBrief | RankInfo; size?: "sm" | "md"; showRating?: boolean } = $props();

  // Slifer red, Ra gold, Obelisk blue, Master violet, Beginner slate.
  const COLORS: Record<RankSchool, string> = {
    beginner: "#9fb0c3",
    slifer: "#ff5a4d",
    ra: "#ffc23c",
    obelisk: "#46b6ff",
    master: "#c98bff",
  };
  const fg = $derived(COLORS[rank.school]);
</script>

<span
  class="inline-flex items-center gap-1.5 font-display font-semibold tracking-wide {size === 'sm'
    ? 'text-[11px]'
    : 'text-xs'}"
  style="color:{fg}"
>
  <span class="inline-block size-1.5 rotate-45 rounded-[1px]" style="background:{fg};box-shadow:0 0 6px {fg}"></span>
  <span style="text-shadow:0 0 8px {fg}66">{rank.label}</span>
  {#if showRating}
    <span class="font-normal text-ink-dim">{rank.rating}</span>
  {/if}
</span>
